/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro"
import React from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { sortableHandle } from "react-sortable-hoc"

const DragHandle = sortableHandle(() => {
    return(
        <i className="fas fa-arrows-alt" />
    )
})

const componentStyle = css`
    i{
        cursor: pointer;
    }
`

class AbovegroundStorageTank extends React.Component{

    state = {
        id: null,
        locationId: "None",
        tankAgeInNumber: "",
        construction: "None",
        otherConstruction: "",
        capacityInNumber: "",
        contents: "None",
        otherContents: "",
        leakDetection: "",
        secondaryContainment: "",
        retroactiveDateOnExistingPolicyUtc: null,
        deductible: "None"
    }

    componentDidMount = async ()=>{
        const { abovegroundStorageTank, applicationsContainer } = this.props
        const agst = applicationsContainer.state.abovegroundStorageTanksMap.get(abovegroundStorageTank)

        await this.setState({
            id: agst.id,
            locationId: agst.locationId ? agst.locationId : "None",
            tankAgeInNumber: agst.tankAgeInNumber ? agst.tankAgeInNumber : "",
            construction: agst.construction ? agst.construction : "None",
            otherConstruction: agst.otherConstruction,
            capacityInNumber: agst.capacityInNumber ? agst.capacityInNumber : "",
            contents: agst.contents ? agst.contents : "None",
            otherContents: agst.otherContents,
            leakDetection: agst.leakDetection ? agst.leakDetection.toLowerCase() : "",
            secondaryContainment: agst.secondaryContainment ? agst.secondaryContainment.toLowerCase() : "",
            retroactiveDateOnExistingPolicyUtc: agst.retroactiveDateOnExistingPolicyUtc ? new Date(agst.retroactiveDateOnExistingPolicyUtc) : null,
            deductible: agst.deductible ? agst.deductible : "None"
        })

        if(!agst.retroactiveDateOnExistingPolicyUtc){
            this.setDate(new Date(applicationsContainer.state.currentApplication.dateEffectiveUtc), "retroactiveDateOnExistingPolicyUtc")
        }

    }

    updateValue = async (e)=>{
        e = e.currentTarget
        let value = e.value
        let name = e.name
        
        if(name.includes("leakDetection")){
            name = "leakDetection"
        }else if(name.includes("secondaryContainment")){
            name = "secondaryContainment"
        }

        await this.setState({
            [name]: value
        })

        if(name === "construction" && value !== "Other"){
            await this.setState({
                otherConstruction: ""
            })
        }else if(name === "contents" && value !== "Other"){
            await this.setState({
                otherContents: ""
            })
        }

        if(name === "locationId" ||
           name === "construction" ||
           name === "contents" ||
           name === "deductible" ||
           name === "leakDetection" ||
           name === "secondaryContainment"){
            this.updateStorageTank()
        }
    }

    setDate = async (date, name)=>{
        await this.setState({
            [name]: date
        })

        this.updateStorageTank()
    }

    updateStorageTank = ()=>{
        const { applicationsContainer } = this.props
        applicationsContainer.updateAbovegroundStorageTank(this.state)
    }

    deleteStorageTank = async ()=>{
        const { applicationsContainer } = this.props
        let confirm = window.confirm("Are you sure you want to delete this Storage Tank?")
        if(confirm){
           await applicationsContainer.deleteAbovegroundStorageTanks([this.state.id])
        }
    }

    cloneStorageTank = async ()=>{
        const { applicationsContainer } = this.props
        await applicationsContainer.cloneAbovegroundStorageTank(this.state.id)
    }

    render(){
        const { applicationsContainer } = this.props
        const isValidating = applicationsContainer.state.isValidating

        return(            
            <tr css={componentStyle}>
                <td className="action"><DragHandle /></td>
                <td>
                    <select className={"form-control form-control-sm" + ((isValidating && this.state.locationId === "None") ? " required" : "")}
                            id="locationId"
                            name="locationId"
                            onChange={this.updateValue}
                            value={this.state.locationId}> 
                        <option value="None">Select</option>
                        {applicationsContainer.state.locations.map((location, index)=>(
                            (applicationsContainer.state.locationsMap.get(location).address &&
                                <option key={index}
                                        value={location}>
                                    {applicationsContainer.state.locationsMap.get(location).address}
                                </option>
                            ))
                        )}
                    </select>
                </td>
                <td>
                    <input type="number" 
                           className={"form-control form-control-sm" + ((isValidating && (!this.state.tankAgeInNumber || this.state.tankAgeInNumber === "0")) ? " required" : "")}
                           id="tankAgeInNumber"
                           name="tankAgeInNumber"
                           value={this.state.tankAgeInNumber}
                           onChange={this.updateValue}
                           onBlur={this.updateStorageTank} />
                </td>
                <td>
                    <div className="form-group">
                        <select className={"form-control form-control-sm" + ((isValidating && this.state.construction === "None") ? " required" : "")}
                                id="construction"
                                name="construction"
                                onChange={this.updateValue}
                                value={this.state.construction}> 
                            <option value="None">Select</option>
                            {applicationsContainer.state.abovegroundConstructions.map((construction, index)=>(
                                (construction.id !== "None" &&
                                    <option key={index}
                                            value={construction.id}>
                                        {construction.name}
                                    </option>
                                )
                            ))}
                        </select>
                    </div>
                    {this.state.construction === "Other" &&
                        <div className="form-group">
                            <input type="text" 
                                   className={"form-control form-control-sm" + ((isValidating && this.state.otherConstruction === "") ? " required" : "")}
                                   id="otherConstruction" 
                                   name="otherConstruction"
                                   onChange={this.updateValue}
                                   onBlur={this.updateStorageTank}
                                   value={this.state.otherConstruction}
                                   placeholder="Enter Construction" />
                        </div>
                    }
                </td>
                <td>
                <input type="number" 
                       className={"form-control form-control-sm" + ((isValidating && (!this.state.capacityInNumber || this.state.capacityInNumber === "0")) ? " required" : "")}
                       id="capacityInNumber"
                       name="capacityInNumber"
                       value={this.state.capacityInNumber}
                       onChange={this.updateValue}
                       onBlur={this.updateStorageTank} />
                </td>
                <td>
                    <div className="form-group">
                        <select className={"form-control form-control-sm" + ((isValidating && this.state.contents === "None") ? " required" : "")}
                                id="contents"
                                name="contents"
                                onChange={this.updateValue}
                                value={this.state.contents}> 
                            <option value="None">Select</option>
                            {applicationsContainer.state.abovegroundContents.map((content, index)=>(
                                (content.id !== "None" &&
                                    <option key={index}
                                            value={content.id}>
                                        {content.name}
                                    </option>
                                )
                            ))}
                        </select>
                    </div>
                    {this.state.contents === "Other" &&
                        <div className="form-group">
                            <input type="text" 
                                   className={"form-control form-control-sm" + ((isValidating && this.state.otherContents === "") ? " required" : "")}
                                   id="otherContents" 
                                   name="otherContents"
                                   onChange={this.updateValue}
                                   onBlur={this.updateStorageTank}
                                   value={this.state.otherContents}
                                   placeholder="Enter Contents" />
                        </div>
                    }
                </td>
                <td>
                    <div className="form-check">
                        <input className="form-check-input"
                               type="radio" 
                               id={"leakDetection-"+this.state.id+"-Yes"}
                               name={"leakDetection-"+this.state.id}                               
                               value="yes"
                               checked={this.state.leakDetection === "yes"}
                               onChange={this.updateValue} />
                        <label className={"form-check-label" + ((isValidating && this.state.leakDetection === "") ?" required" : "")}
                               htmlFor={"leakDetection-"+this.state.id+"-Yes"}>
                            Yes
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" 
                               type="radio" 
                               id={"leakDetection-"+this.state.id+"-No"}
                               name={"leakDetection-"+this.state.id}                            
                               value="no"
                               checked={this.state.leakDetection === "no"}
                               onChange={this.updateValue} />
                        <label className={"form-check-label" + ((isValidating && this.state.leakDetection === "") ?" required" : "")}
                               htmlFor={"leakDetection-"+this.state.id+"-No"}>
                            No
                        </label>
                    </div>
                </td>
                <td>
                    <div className="form-check">
                        <input className="form-check-input" 
                               type="radio" 
                               id={"secondaryContainment-"+this.state.id+"-Yes"}
                               name={"secondaryContainment-"+this.state.id}                             
                               value="yes"
                               checked={this.state.secondaryContainment === "yes"}
                               onChange={this.updateValue} />
                        <label className={"form-check-label" + ((isValidating && this.state.secondaryContainment === "") ?" required" : "")}
                               htmlFor={"secondaryContainment-"+this.state.id+"-Yes"}>
                            Yes
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" 
                               type="radio" 
                               id={"secondaryContainment-"+this.state.id+"-No"}
                               name={"secondaryContainment-"+this.state.id}                             
                               value="no"
                               checked={this.state.secondaryContainment === "no"}
                               onChange={this.updateValue} />
                        <label className={"form-check-label" + ((isValidating && this.state.secondaryContainment === "") ?" required" : "")}
                               htmlFor={"secondaryContainment-"+this.state.id+"-No"}>
                            No
                        </label>
                    </div>
                </td>
                <td>
                    <DatePicker popperPlacement="bottom-end"
                                dateFormat="MM/dd/yyyy"
                                className="form-control form-control-sm"
                                id="retroactiveDate"
                                name="retroactiveDate"
                                selected={this.state.retroactiveDateOnExistingPolicyUtc}
                                maxDate={new Date(applicationsContainer.state.currentApplication.dateEffectiveUtc)}
                                onChange={(date)=>{this.setDate(date, "retroactiveDateOnExistingPolicyUtc")}} />
                </td>
                <td>
                    <div className="form-group">
                        <select className={"form-control form-control-sm" + ((isValidating && this.state.deductible === "None") ? " required" : "")}
                                id="deductible"
                                name="deductible"
                                onChange={this.updateValue}
                                value={this.state.deductible}> 
                            <option value="None">Select</option>
                            {applicationsContainer.state.abovegroundDeductibles.map((deductible, index)=>(
                                (deductible.id !== "None" &&
                                    <option key={index}
                                            value={deductible.id}>
                                        {deductible.name}
                                    </option>
                                )
                            ))}
                        </select>
                    </div>
                </td>
                <td className="action">
                    <button className="anchor"
                            onClick={this.cloneStorageTank}
                            disabled={applicationsContainer.state.isLoading}>
                        <i className="fa fa-clone"/>
                    </button>                    
                </td>
                <td className="action">
                    <button className="anchor"
                            onClick={this.deleteStorageTank}
                            disabled={applicationsContainer.state.isLoading}>
                        <i className="fa fa-trash-o"/>
                    </button>
                </td>
            </tr>
        )
    }   
}

export default AbovegroundStorageTank